import {
  FlexBox,
  ModalBody,
  ModalFoot,
  ModalHead,
  Skeleton,
} from '@dixa/lib-shared-habla';
import { Fragment } from 'react';

export function CategoryEditModalLoadingPlaceholder(): JSX.Element {
  return (
    <>
      <ModalHead title="Edit category" />
      <ModalBody>
        {Array.from(Array(3)).map((_, index) => (
          <Fragment key={index}>
            <Skeleton
              height="16px"
              width="64px"
              animation="wave"
              margin="0 0 200"
            />
            <Skeleton
              height="38px"
              width="100%"
              animation="wave"
              margin="0 0 300"
            />
          </Fragment>
        ))}
      </ModalBody>
      <ModalFoot>
        <FlexBox justifyContent="flex-end" alignItems="center" gap="300">
          <Skeleton height="16px" width="38px" animation="wave" />
          <Skeleton height="32px" width="50px" animation="wave" />
        </FlexBox>
      </ModalFoot>
    </>
  );
}
